export const barnesTheme = {
  colors: {
    primary: '#000000', // Black — headings, logo
    accent: '#DB0D43', // Barnes Red (brighter) — used very sparingly
    grege: '#F4F2EE', // Grège — minimal use, max 1-2 highlights per page
    white: '#FFFFFF',
    text: '#3C3C3C', // Dark grey for body text (softer than pure black)
    textLight: '#808080', // Labels, captions, secondary text
    border: '#E5E5E5', // Hairline separators
    background: '#FFFFFF',
    backgroundLight: '#F4F2EE',
    danger: '#dc3545',
  },
  fonts: {
    heading: "'Raleway', sans-serif",
    body: "'Raleway', sans-serif",
    serif: "'Georgia', serif",
  },
  fontSizes: {
    micro: '7px',
    small: '9px',
    body: '10px',
    medium: '11px',
    large: '14px',
    xlarge: '22px',
    huge: '28px',
    title: '36px',
    hero: '42px',
  },
  fontWeights: {
    light: 300,
    normal: 400,
    bold: 700,
  },
  spacing: {
    pageMargin: '16mm',
    sectionGap: '32px',
    contentGap: '20px',
    smallGap: '12px',
    tinyGap: '4px',
  },
  borderRadius: {
    none: '0',
  },
  shadows: {},
  print: {
    pageSize: 'A4',
    pageWidth: '210mm',
    pageHeight: '297mm',
  },
}

export type BarnesTheme = typeof barnesTheme
